import { render, staticRenderFns } from "./CompanyInfoModuleMetaData.vue?vue&type=template&id=7b114718&"
import script from "./CompanyInfoModuleMetaData.vue?vue&type=script&lang=ts&"
export * from "./CompanyInfoModuleMetaData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b114718')) {
      api.createRecord('7b114718', component.options)
    } else {
      api.reload('7b114718', component.options)
    }
    module.hot.accept("./CompanyInfoModuleMetaData.vue?vue&type=template&id=7b114718&", function () {
      api.rerender('7b114718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyInfoModuleMetaData.vue"
export default component.exports